<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import AppIcon from './AppIcon.vue'

const LENGTH = 307.919
const active = ref(false)
const offset = ref(LENGTH)

function update(): void {
  const scrollable = document.documentElement.scrollHeight - window.innerHeight
  const progress = scrollable > 0 ? window.scrollY / scrollable : 0
  offset.value = LENGTH - progress * LENGTH
  active.value = window.scrollY > 150
}
function toTop(): void { window.scrollTo({ top: 0, behavior: 'smooth' }) }
onMounted(() => { window.addEventListener('scroll', update, { passive: true }); update() })
onBeforeUnmount(() => window.removeEventListener('scroll', update))
</script>

<template>
  <button
    type="button"
    class="progress-wrap"
    :class="{ 'active-progress': active }"
    aria-label="Back to top"
    :tabindex="active ? 0 : -1"
    @click="toTop"
  >
    <svg
      class="progress-circle"
      viewBox="-1 -1 102 102"
      aria-hidden="true"
    >
      <path
        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
        :style="{ strokeDasharray: `${LENGTH}, ${LENGTH}`, strokeDashoffset: offset }"
      />
    </svg>
    <span><AppIcon name="chevron-up" /></span>
  </button>
</template>
